import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from 'ui/styled';
import { useOrganizationGroupsQuery } from 'apollo/queries/ORGANIZATION_GROUPS';
var OrganizationGroupsSelect = function (_a) {
    var _b, _c;
    var onChange = _a.onChange, defaultValue = _a.defaultValue, loading = _a.loading, mode = _a.mode;
    var _d = useOrganizationGroupsQuery(), data = _d.data, dataLoading = _d.loading;
    var options = (_c = (_b = data === null || data === void 0 ? void 0 : data.organization_groups) === null || _b === void 0 ? void 0 : _b.nodes) === null || _c === void 0 ? void 0 : _c.map(function (item) { return ({
        value: item.id,
        label: item.name
    }); });
    return (_jsx(Select, { mode: mode, options: options, loading: loading || dataLoading, onChange: onChange, value: defaultValue, placeholder: "Organization groups" }));
};
export default OrganizationGroupsSelect;
